import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
// COMPONENTES
import ZonaCargando from "../alertas/zonaCargando";
import axios from "axios";
import CardServicio from "../../componentesEspeciales/cardServicio";
import HelmetSEO from '../../componentesEspeciales/helmetSEO';

function UsuarioServicios(){

    const { username } = useParams();
    const navigate = useNavigate();
    const [cargando, setCargando]   = useState(false);
    const [existe, setExiste]       = useState(null);
    const [usuario, setUsuario]     = useState(null);
    const [servicios, setServicios] = useState([]);

    useEffect(() => {
        if(!username) return;

        (async () => {

            try{
                setCargando(true);
                const resUs = await axios.post("/buscar-servicios-username", {
                    params: { username }
                });

                setExiste(Boolean(resUs?.data?.existe));
                setUsuario(resUs?.data?.usuario || null);
                setServicios(Array.isArray(resUs?.data?.servicios) ? resUs.data.servicios : []);

            }
            catch(err){
                console.log(err);
                setExiste(false);
                setUsuario(null);
                setServicios([]);
            }
            finally {setCargando(false);}

        })();
    }, [username]);

    function nombreCompletoUsuario() {
        const nombre = usuario?.nombre || "";
        const apellido = usuario?.apellido || "";
        const nombreCompleto = `${nombre} ${apellido}`.trim();
        return nombreCompleto || usuario?.username || username;
    }

    function avatarUsuario() {
        return usuario?.avatar || "/imagenes/marca/avatar.png";
    }

    return(
        <>
            {/*
                SEO dinámico del perfil público del vendedor.
                Cambia automáticamente:
                - título
                - descripción SEO
                - Open Graph
                según el usuario actual.
            */}
            <HelmetSEO
                titulo={`Servicios de ${usuario?.username || username} | Zervicy`}
                descripcion={`Explora los servicios publicados por ${nombreCompletoUsuario()} en Zervicy y encuentra opciones confiables para reservar fácilmente.`}
                imagen={avatarUsuario()}
            />

            <div className="bg-light min-vh-100">
            {cargando ? (
                <ZonaCargando />
            ) : existe ? (
                <div>
                    <section className="position-relative overflow-hidden" style={{ background: "linear-gradient(135deg, var(--azul-logo-fondo) 0%, var(--azul-medio) 55%, var(--azul-logo-claro) 100%)" }}>
                        <div className="container py-5">
                            <div className="row align-items-center g-4">
                                <div className="col-12 col-lg-8 text-white">
                                    <span className="badge rounded-pill px-3 py-2 mb-3" style={{ background: "rgba(var(--naranja-cta-rgb), .18)", color: "var(--naranja-cta)", border: "1px solid rgba(var(--naranja-cta-rgb), .35)" }}>
                                        Perfil de vendedor en Zervicy
                                    </span>

                                    <h1 className="display-5 fw-bold mb-3">
                                        Servicios de {nombreCompletoUsuario()}
                                    </h1>

                                    <p className="lead mb-0" style={{ color: "rgba(var(--blanco-rgb), .82)" }}>
                                        Explora los servicios disponibles, revisa los detalles y elige el que mejor se ajuste a lo que necesitas.
                                    </p>
                                </div>

                                <div className="col-12 col-lg-4">
                                    <div className="card border-0 shadow-lg rounded-4 overflow-hidden">
                                        <div className="card-body p-4 text-center">
                                            <img
                                                src={avatarUsuario()}
                                                alt={nombreCompletoUsuario()}
                                                className="rounded-circle object-fit-cover border border-4 border-white shadow-sm mb-3"
                                                style={{ width: "112px", height: "112px" }}
                                            />
                                            <h2 className="h4 fw-bold mb-1">{nombreCompletoUsuario()}</h2>
                                            <p className="text-secondary mb-3">@{usuario?.username || username}</p>

                                            <div className="d-flex justify-content-center gap-2 flex-wrap">
                                                <span className="badge rounded-pill bg-light text-dark border px-3 py-2">
                                                    {servicios?.length || 0} servicio(s)
                                                </span>
                                                {usuario?.ciudad && usuario?.ciudad !== "NA" ? (
                                                    <span className="badge rounded-pill bg-light text-dark border px-3 py-2">
                                                        {usuario.ciudad}
                                                    </span>
                                                ) : null}
                                            </div>

                                            <button
                                                type="button"
                                                className="btn btn-outline-secondary btn-sm mt-3 d-flex align-items-center gap-2 mx-auto"
                                                onClick={async () => {
                                                    const url = `${window.location.origin}/${usuario?.username || username}`;
                                                    if (navigator.share) {
                                                        try { await navigator.share({ title: `Servicios de ${nombreCompletoUsuario()} | Zervicy`, url }); } catch {}
                                                    } else {
                                                        await navigator.clipboard.writeText(url);
                                                        alert("¡Enlace copiado!");
                                                    }
                                                }}
                                            >
                                                <i className="bi bi-share"></i>
                                                Compartir perfil
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="container py-5">
                        <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-end gap-2 mb-4">
                            <div>
                                <h2 className="fw-bold mb-1">Servicios disponibles</h2>
                                <p className="text-secondary mb-0">Estos son los servicios publicados por este vendedor.</p>
                            </div>
                            <span className="badge rounded-pill bg-white text-dark border px-3 py-2 shadow-sm align-self-start align-self-md-auto">
                                {servicios?.length || 0} resultado(s)
                            </span>
                        </div>

                        {servicios?.length > 0 ? (
                            <div className="row g-4 align-items-stretch">
                                {servicios.map((servicio) => (
                                    <div className="col-12 col-md-6 col-xl-4 d-flex" key={servicio?._id || servicio?.idServicio}>
                                        <div className="w-100">
                                            <CardServicio servicio={servicio} clampDesc={3} textoBoton="Ver servicio" desdeDonde={"busqueda"} />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="card border-0 shadow-sm rounded-4">
                                <div className="card-body p-5 text-center">
                                    <h3 className="h5 fw-bold mb-2">Aún no hay servicios publicados</h3>
                                    <p className="text-secondary mb-0">Este usuario todavía no tiene servicios disponibles para compartir.</p>
                                </div>
                            </div>
                        )}
                    </section>

                    <footer className="mt-4" style={{ background: "var(--azul-logo-fondo)" }}>
                        <div className="container py-5">
                            <div className="row align-items-center g-4">
                                <div className="col-12 col-lg-7 text-white">
                                    <span className="badge rounded-pill px-3 py-2 mb-3" style={{ background: "rgba(var(--naranja-cta-rgb), .18)", color: "var(--naranja-cta)", border: "1px solid rgba(var(--naranja-cta-rgb), .35)" }}>
                                        Zervicy
                                    </span>
                                    <h2 className="fw-bold mb-2">¿Necesitas un servicio confiable?</h2>
                                    <p className="mb-0" style={{ color: "rgba(var(--blanco-rgb), .75)" }}>
                                        Encuentra, reserva y paga servicios locales y digitales de forma segura. Este perfil hace parte de Zervicy y sus servicios han sido revisados antes de estar disponibles en la plataforma.
                                    </p>
                                </div>

                                <div className="col-12 col-lg-5 d-flex flex-column flex-sm-row gap-2 justify-content-lg-end">
                                    <button
                                        type="button"
                                        className="btn rounded-pill px-4 fw-semibold"
                                        style={{ background: "var(--naranja-cta)", color: "var(--blanco)" }}
                                        onClick={() => navigate("/preguntas")}
                                    >
                                        ¿Cómo funciona?
                                    </button>

                                    <button
                                        type="button"
                                        className="btn btn-outline-light rounded-pill px-4 fw-semibold"
                                        onClick={() => navigate(`/${usuario?.username || username}/te-invito-a-zervicy`)}
                                    >
                                        Vender en Zervicy
                                    </button>
                                </div>
                            </div>

                            <hr className="border-light opacity-25 my-4" />

                            <div className="d-flex flex-column flex-md-row justify-content-between gap-2" style={{ color: "rgba(var(--blanco-rgb), .65)" }}>
                                <small>© 2026 Zervicy. Ofrece y contrata servicios locales y digitales en Colombia.</small>
                                <small>
                                    Powered by{" "}
                                    <a href="https://pretwor.com/" target="_blank" rel="noopener noreferrer" style={{ color: "rgba(var(--blanco-rgb), .85)", textDecoration: "none" }}>Pretwor</a>
                                    {" · "}
                                    <a href="https://eduardoarias.co/" target="_blank" rel="noopener noreferrer" style={{ color: "rgba(var(--blanco-rgb), .85)", textDecoration: "none" }}>Eduardo Arias</a>
                                </small>
                            </div>
                        </div>
                    </footer>
                </div>
            ) : (
                <div className="container py-5">
                    <div className="card border-0 shadow-sm rounded-4 mx-auto" style={{ maxWidth: "560px" }}>
                        <div className="card-body p-5 text-center">
                            <h1 className="h3 fw-bold mb-2">Usuario no encontrado</h1>
                            <p className="text-secondary mb-0">El perfil que estás intentando ver no existe o ya no está disponible.</p>
                        </div>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}


export default UsuarioServicios;